import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IOrganisation } from "../../organisations/model/Organisation";
import OrganisationMapper from "../../organisations/service/OrganisationMapper";
import OrganisationParamMapper from "../../organisations/service/OrgansationParamMapper";
import Constants from "../common/Constants";

export default class GetAllOrganisationsInteractor {
  private resource: GetAllResourceEntriesInteractor<IOrganisation>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      Constants.organisationsPath,
      OrganisationMapper,
      OrganisationParamMapper
    );
  }
}
